import React from 'react';
import './PDFSummaryStep.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes, faEdit, faFileAlt } from '@fortawesome/free-solid-svg-icons';

const PDFSummaryStep = ({ 
    pdfConfig,
    catalog,
    productCount,
    onEditStep
}) => {
    
    // Obtener nombre del layout
    const getLayoutName = () => {
        const names = {
            'alternado': 'Alternado',
            'doble-columna': 'Doble Columna',
            'grid-3x3': 'Grid 3x3'
        };
        return names[pdfConfig.layout] || pdfConfig.layout;
    };

    // Obtener nombre de la paleta
    const getPaletteName = () => {
        const names = {
            'orange': 'Naranja Vibrante',
            'blue': 'Azul Profesional',
            'green': 'Verde Natural',
            'purple': 'Púrpura Elegante',
            'red': 'Rojo Intenso',
            'teal': 'Turquesa Moderno',
            'pink': 'Rosa Creativo',
            'gray': 'Gris Minimalista'
        };
        return names[pdfConfig.colorPalette] || pdfConfig.colorPalette;
    };

    // Obtener nombre de la fuente
    const getFontName = () => {
        const names = {
            'modern': 'Moderna',
            'classic': 'Clásica',
            'elegant': 'Elegante',
            'bold': 'Bold'
        };
        return names[pdfConfig.font] || pdfConfig.font;
    };

    // Calcular páginas estimadas (aproximado)
    const estimatedPages = () => {
        if (!productCount) return 1;
        
        let productsPerPage = 4; // Default
        if (pdfConfig.layout === 'doble-columna') productsPerPage = 8;
        if (pdfConfig.layout === 'grid-3x3') productsPerPage = 9;
        if (pdfConfig.layout === 'magazine') productsPerPage = 7;
        
        const contentPages = Math.ceil(productCount / productsPerPage);
        const coverPage = 1;
        const contactPage = pdfConfig.showContactPage ? 1 : 0;
        
        return coverPage + contentPages + contactPage;
    };

    return (
        <div className="pdf-summary-step-container">
            
            {/* Información del Catálogo */}
            <div className="pdf-summary-section pdf-summary-catalog-info">
                <div className="pdf-summary-icon-header">
                    <FontAwesomeIcon icon={faFileAlt} />
                    <h3>Información del Catálogo</h3>
                </div>
                <div className="pdf-summary-info-grid">
                    <div className="pdf-summary-info-item">
                        <span className="pdf-summary-label">Nombre:</span>
                        <span className="pdf-summary-value">{catalog?.name || 'Sin nombre'}</span>
                    </div>
                    <div className="pdf-summary-info-item">
                        <span className="pdf-summary-label">Productos:</span>
                        <span className="pdf-summary-value">{productCount || 0}</span>
                    </div>
                    <div className="pdf-summary-info-item">
                        <span className="pdf-summary-label">Páginas estimadas:</span>
                        <span className="pdf-summary-value">{estimatedPages()}</span>
                    </div>
                </div>
            </div>

            {/* Resumen de Diseño */}
            <div className="pdf-summary-section">
                <div className="pdf-summary-section-header">
                    <h4>Diseño y Estilo</h4>
                    <button className="pdf-summary-edit-btn" onClick={() => onEditStep(1)}>
                        <FontAwesomeIcon icon={faEdit} />
                        Editar
                    </button>
                </div>
                <div className="pdf-summary-items">
                    <div className="pdf-summary-item">
                        <span className="pdf-summary-item-label">Layout:</span>
                        <span className="pdf-summary-item-value">{getLayoutName()}</span>
                    </div>
                    <div className="pdf-summary-item">
                        <span className="pdf-summary-item-label">Paleta de colores:</span>
                        <span className="pdf-summary-item-value">{getPaletteName()}</span>
                    </div>
                    <div className="pdf-summary-item">
                        <span className="pdf-summary-item-label">Tipografía:</span>
                        <span className="pdf-summary-item-value">{getFontName()}</span>
                    </div>
                </div>
            </div>

            {/* Resumen de Contenido */}
            <div className="pdf-summary-section">
                <div className="pdf-summary-section-header">
                    <h4>Contenido</h4>
                    <button className="pdf-summary-edit-btn" onClick={() => onEditStep(3)}>
                        <FontAwesomeIcon icon={faEdit} />
                        Editar
                    </button>
                </div>
                <div className="pdf-summary-items">
                    <div className="pdf-summary-item">
                        <span className="pdf-summary-item-label">Tipo de portada:</span>
                        <span className="pdf-summary-item-value">
                            {pdfConfig.coverType === 'banner' ? 'Banner personalizado' : 'Portada generada'}
                        </span>
                    </div>
                </div>
                
                <div className="pdf-summary-checkboxes">
                    <div className={`pdf-summary-checkbox-item ${pdfConfig.showContactPage ? 'checked' : ''}`}>
                        <FontAwesomeIcon icon={pdfConfig.showContactPage ? faCheck : faTimes} />
                        <span>Página de contacto</span>
                    </div>
                    <div className={`pdf-summary-checkbox-item ${pdfConfig.removeBackgrounds ? 'checked' : ''}`}>
                        <FontAwesomeIcon icon={pdfConfig.removeBackgrounds ? faCheck : faTimes} />
                        <span>Remover fondos de imágenes</span>
                    </div>
                </div>
            </div>

            {/* Nota informativa */}
            <div className="pdf-summary-note">
                <p>
                    Al hacer clic en "Generar PDF", se creará tu catálogo con todas las configuraciones seleccionadas.
                    {pdfConfig.removeBackgrounds && ' El proceso puede tardar varios minutos debido a la remoción de fondos.'}
                </p>
            </div>

        </div>
    );
};

export default PDFSummaryStep;
